import React, { useState } from 'react';
import Select from '@atlaskit/select';
import { TransactionAccount, CommerceAddress } from '@css-xp/graphtypes';

export interface shipToAddressesType {
  transactionAccount: TransactionAccount;
}

export const formatAddressLabel = (node: CommerceAddress, skipName?: boolean) => {
  let label = '';

  /*istanbul ignore next*/
  if (skipName) {
    if (node?.addressLine1) {
      label += `${node.addressLine1}`;
    }
  } else {
    if (node?.name) {
      label += node.name;
    }
    if (node?.addressLine1) {
      label += `, ${node.addressLine1}`;
    }
  }

  if (node?.addressLine2) {
    label += `, ${node.addressLine2}`;
  }
  if (node?.city) {
    label += `, ${node.city}`;
  }
  if (node?.state) {
    label += `, ${node.state}`;
  }
  if (node?.country) {
    label += `, ${node.country}`;
  }

  return label;
};

export const SelectShipToAddress = ({
  onSelect,
  shipToAddresses,
  countryCode,
  isMultiCurrencyChangesEnabled = false,
  isNewSoldToAddressDisabled = false,
}: {
  onSelect: (option: any) => void;
  shipToAddresses: shipToAddressesType | undefined;
  countryCode?: string | null;
  isMultiCurrencyChangesEnabled?: boolean;
  isNewSoldToAddressDisabled?: boolean;
}) => {
  const [value, setValue] = useState(undefined);
  const showSelectShipToAddress = () => {
    const hasNoResults =
      !shipToAddresses || shipToAddresses?.transactionAccount?.availableShipToParties?.totalCount === 0;
    return !hasNoResults;
  };

  let availableShipToParties = shipToAddresses?.transactionAccount.availableShipToParties?.nodes;

  /*If selected country is japan then show only japan addresses and 
  if it is not japan then show all other addresses*/
  if (isMultiCurrencyChangesEnabled) {
    availableShipToParties = availableShipToParties?.filter((node) => {
      return countryCode === 'JP' ? node?.country === 'JP' : node?.country !== 'JP';
    });
  }

  const selectOptions = availableShipToParties?.map((node) => {
    return {
      label: node && formatAddressLabel(node),
      value: node,
    };
  });

  const handleSelect = (option: any) => {
    onSelect(option);
    setValue(option);
  };

  return showSelectShipToAddress() ? (
    <Select
      onChange={handleSelect}
      options={selectOptions}
      placeholder={'Select an existing sold-to address'}
      id="selectShipTo"
      data-testid="select"
      isClearable
      value={value}
      isDisabled={isNewSoldToAddressDisabled}
    />
  ) : (
    <Select options={[]} placeholder={'No sold-to addresses exist'} />
  );
};
